import { useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { formatMoney } from "../lib/currency";

export default function SalaryDialog({ open, onOpenChange }) {
  const [data, setData] = useState(null);
  const [edits, setEdits] = useState({});
  const [hours, setHours] = useState("");
  const [q, setQ] = useState("");

  const load = async () => {
    const { data } = await api.get("/salaries");
    setData(data); setHours(String(data.working_hours_per_month)); setEdits({});
  };
  useEffect(() => { if (open) { load().catch(e => toast.error(formatApiError(e.response?.data?.detail))); } }, [open]);

  const saveHours = async () => {
    try { await api.put("/salary-settings", { working_hours_per_month: Number(hours) }); toast.success("Working hours updated"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const saveOne = async (m) => {
    const v = edits[m.id];
    if (v === undefined || v === "" || Number(v) < 0) { toast.error("Enter a salary of 0 or more"); return; }
    try { await api.put(`/salaries/${m.id}`, { monthly_salary: Number(v) }); toast.success(`Salary saved for ${m.name}`); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const members = (data?.members || []).filter(m => !q || `${m.name} ${m.email} ${m.role}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FFFFFF] border-[#E4E7EC] max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="salary-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">Salaries</DialogTitle>
          <DialogDescription className="text-neutral-600 text-xs">Monthly salary in ₹. Hourly rate = salary ÷ working hours per month, used to cost the hours logged on project tasks. Only Admin, COO and CEO can see this.</DialogDescription>
        </DialogHeader>
        <div className="flex items-end gap-2 flex-wrap">
          <div>
            <div className="text-[10px] font-mono uppercase text-neutral-500 mb-1">Working hours / month</div>
            <Input type="number" min="1" max="400" value={hours} onChange={e => setHours(e.target.value)} className="w-32 bg-[#FFFFFF] border-[#E4E7EC]" data-testid="salary-hours-input" />
          </div>
          <Button variant="outline" onClick={saveHours} data-testid="salary-hours-save">Update</Button>
          <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search team..." className="ml-auto w-48 bg-[#FFFFFF] border-[#E4E7EC]" data-testid="salary-search" />
        </div>
        <div className="divide-y divide-[#E4E7EC] border border-[#E4E7EC] rounded-lg">
          {!data && <div className="p-4 text-sm text-neutral-500">Loading…</div>}
          {data && members.length === 0 && <div className="p-4 text-sm text-neutral-500">No team members found.</div>}
          {members.map(m => (
            <div key={m.id} className="flex items-center gap-3 p-3 flex-wrap" data-testid={`salary-row-${m.id}`}>
              <div className="flex-1 min-w-[160px]">
                <div className="text-sm font-medium break-words">{m.name}</div>
                <div className="text-[10px] font-mono text-neutral-500 break-words" data-testid={`salary-rate-${m.id}`}>{m.role} · {m.monthly_salary ? `${formatMoney(m.hourly_rate, "INR")}/hr` : "no salary set"}</div>
              </div>
              <div className="relative">
                <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-neutral-500">₹</span>
                <Input type="number" min="0" step="any" placeholder="Monthly" value={edits[m.id] ?? (m.monthly_salary || "")}
                  onChange={e => setEdits({ ...edits, [m.id]: e.target.value })} className="w-36 pl-6 bg-[#FFFFFF] border-[#E4E7EC]" data-testid={`salary-input-${m.id}`} />
              </div>
              <Button size="sm" disabled={edits[m.id] === undefined} onClick={() => saveOne(m)} className="bg-orange-500 hover:bg-orange-600 text-white" data-testid={`salary-save-${m.id}`}>Save</Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
